import { gql } from 'apollo-angular';

export const CREATE_JOURNAL = gql`
  mutation createJournal($createJournalInput: CreateJournalInput!,$journalEntries: [CreateJournalEntryInput]) {
    createJournal(createJournalInput: $createJournalInput,journalEntries: $journalEntries) {
      id
      journalNo
      reference
    }
  }
`;

export const REMOVE_JOURNAL = gql`
  mutation removeJournal($id: Int!) {
    removeJournal(id: $id)
  }
`;
export const REMOVE_JOURNAL_ENTRY = gql`
  mutation removeJournalEntry($id: Int!) {
    removeJournalEntry(id: $id)
  }
`;

export const UPDATE_JOURNAL = gql`
  mutation updateJournal( $updateJournalInput: UpdateJournalInput!, $journalEntries: [UpdateJournalEntryInput]) {
    updateJournal(updateJournalInput: $updateJournalInput,journalEntries: $journalEntries) {
      id
    journalNo
    refType
    refId
    reference
    notes
    createdBy
    postedAt
    status
    date
    createdAt
    updatedAt
    deletedAt
    }
  }
`;

export const PUBLISH_JOURNAL = gql`
  mutation publishJournal($id: Int!) {
    publishJournal(id: $id)
  }
`;